var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"livePreviewIframe",style:({
    width: _vm.$store.getters['themeEditor/iframeWidth']
  }),attrs:{"id":"livePreview","src":_vm.$store.getters['themeEditor/iframeUrl']}})}
var staticRenderFns = []

export { render, staticRenderFns }